import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";


export const fetchConcerns = async (coachId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.FETCH_CONCERNS_LIST}/${coachId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch Concerns");
  }
};

export const fetchConversationList = async (issueId) => {
    try {
      const response = await axiosInstance.get(
        `${Endpoints.FETCH_CONCERNS_CONVERSATION_LIST}/${issueId}`
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || "Failed to fetch conversation");
    }
  };

  export const PostConcernConversation = async ({message}) => {
    try {
      const response = await axiosInstance.post(
        Endpoints.POST_CONCERNS_CONVERSATION,
        message
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || "Failed to post concern");
    }
  };

  export const createSupportTicket = async (formData) => {
    try {
      const response = await axiosInstance.post(
        Endpoints.CREATE_SUPPORT_TICKET,
        formData
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data || "Failed to post concern");
    }
  };



  
  
